import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { contactsApi } from '../../api/contacts';
import { queryKeys } from '../queryClient';
import type { ContactStatus } from '../../types/domain';

export function useContacts(status?: ContactStatus, cursor?: string) {
  return useQuery({
    queryKey: queryKeys.contacts(status, cursor),
    queryFn: () => contactsApi.list(status, cursor),
  });
}

export function useContact(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.contact(id ?? ''),
    queryFn: () => contactsApi.get(id!),
    enabled: !!id,
  });
}

export function useSetContactStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status, rowVersion }: { id: string; status: ContactStatus; rowVersion?: number }) =>
      contactsApi.setStatus(id, status, rowVersion),
    onSuccess: (_res, vars) => {
      qc.invalidateQueries({ queryKey: ['contacts'] });
      qc.invalidateQueries({ queryKey: queryKeys.contact(vars.id) });
    },
  });
}

export function useDeleteContact() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => contactsApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['contacts'] }),
  });
}
